export default __webpack_public_path__ + "static/media/QA.159daa7e.svg";